import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MdButtonModule } from '@angular2-material/button';
import { MdCardModule } from '@angular2-material/card';
import { MdIconModule, MdIconRegistry } from '@angular2-material/icon';
import { MdSidenavModule, MdSidenav } from '@angular2-material/sidenav';
import { MdToolbarModule, MdToolbar } from '@angular2-material/toolbar';
import { MdMenuModule } from '@angular2-material/menu';
import { Overlay, OVERLAY_PROVIDERS } from '@angular2-material/core';
import { MdInputModule } from '@angular2-material/input';
import { MdListModule } from '@angular2-material/list';
import { MdGridListModule } from '@angular2-material/grid-list';
import { MdCheckboxModule } from '@angular2-material/checkbox';
import { MdProgressBarModule } from '@angular2-material/progress-bar';

import { AboutComponent } from './about/about.component';
import { SolutionsComponent } from './solutions/solutions.component';
import { FinesseComponent } from './solutions/finesse/finesse.component';
import { FiscalComponent } from './solutions/fiscal/fiscal.component';
import { ServicesComponent } from './services/services.component';
import { ClientsComponent } from './clients/clients.component';
import { ContactUsComponent } from './contactus/contactus.component';
import { NewsComponent } from './news/news.component';

import { EnquiryService } from './api.service';
import { DataService } from './api.data.service';

import { routing } from './routes';

import { RecaptchaModule } from 'ng2-recaptcha';

import { CollapseDirective } from 'ng2-bootstrap/components/collapse';

import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster/angular2-toaster';

import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        BrowserModule,
        HttpModule,
        MdButtonModule,
        MdCardModule,
        MdIconModule,
        MdSidenavModule,
        MdToolbarModule,
        MdMenuModule,
        MdInputModule,
        MdListModule,
        MdGridListModule,
        MdCheckboxModule,
        MdProgressBarModule,
        routing,
        CommonModule,
        FormsModule,
        RecaptchaModule.forRoot(),
        
        ToasterModule,
        ReactiveFormsModule,
    
    ],
    providers: [MdIconRegistry,
        MdToolbar,
        MdSidenav,
        Overlay,
        OVERLAY_PROVIDERS,
        EnquiryService,
        DataService
    ], 
    declarations: [
        AppComponent,
        AboutComponent,
        SolutionsComponent,
        ServicesComponent,
        ClientsComponent,
        ContactUsComponent,
        NewsComponent,
        FiscalComponent,
        FinesseComponent,

        CollapseDirective,
    ],
    
    bootstrap: [AppComponent]
})
export class AppModule {
    

    constructor(mdIconRegistry: MdIconRegistry)
    {
        mdIconRegistry.registerFontClassAlias('fontawesome', 'fa');
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/app.module.ts
 **/